<template>
  <div class="container" :data-corp-id="corpId">
    <div class="relWel-success" v-if="type==1">
      <div class="welSuccess">
        <i class="welSuccess-icon"></i>
      </div>
      <div class="welSuccessTitle">
        <h2>领取成功啦</h2>
      </div>
      <div class="welSuccessBtn">


        <router-link :to="{ path: '/order/detail',query:{orderId:orderId} }" >
            <button class="watchWel welSuccess-btn">查看福利</button>
        </router-link>
        <router-link :to="{ path: '/care'}" >
        <button class="backHome welSuccess-btn">返回首页</button>
        </router-link>
      </div>
    </div>
    <div class="virWel-success relWel-success"  v-if="type==2">
      <div class="welSuccess">
        <i class="welSuccess-icon"></i>
      </div>
        <div class="welSuccessTitle" v-if="extensionVirtualCode=='no_require_mobile' && !mobile">
        <h2>领取成功啦</h2>
        <dl class="virtual no_require_mobile_msg" >
        <dd>派发有延迟，请耐心等待</dd>
        <dd>请一小时后由『我的福利』进入此处查看结果</dd>
        </dl> 
      </div>
      <div class="welSuccessTitle" v-if="!extensionVirtualCode && mobile">
        <!-- <h2>领取成功啦<br>卡密已发送至&nbsp;{{mobile}}</h2> -->
        <h2>请至福利订单页查看领取到的卡密</h2>
        <span class="welTips">请注意保密，被坏宝宝抢去了，关怀君也打不过哦</span>
      </div>
      <div class="welSuccessBtn">
        <router-link :to="{ path: '/order/detail',query:{orderId:orderId} }" >
          <button class="watchWel welSuccess-btn">查看福利</button>
        </router-link>
        <router-link :to="{ path: '/care'}" >
          <button class="backHome welSuccess-btn">返回首页</button>
        </router-link>
      </div>
    </div>
    <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import home from '../common/home.vue'
export default {
  data () {
    return {
     	  type:0,
        mobile:0,
        orderId:0,
        extensionVirtualCode:'',

    }
  },
  components:{
    home
  },
  computed:{
  	 ...mapGetters({
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },
  },
  watch:{

  },
  created(){
      this.type = this.$route.query.type;
      this.mobile = this.$route.query.mobile;
      this.orderId = this.$route.query.oid;
    this.extensionVirtualCode = this.$route.query.extensionVirtualCode

  },
  methods:{

  },
  mounted(){
      document.body.className = 'routeReady bgfff';
  }
}
</script>